<template>
  <div class="massLoss-list" v-loading="pageLoading">
    <div class="nav">
      <el-form :model="searchForm" label-width="110px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="供应商：">
          <el-input v-model="searchForm.name" size="mini" placeholder="请输入供应商"></el-input>
        </el-form-item>
        <el-form-item label="是否完善：">
          <el-select v-model="searchForm.status" filterable size="mini" placeholder="请选择是否完善">
            <el-option label="全部" value=""></el-option>
            <el-option label="已完善" :value="1"></el-option>
            <el-option label="未完善" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="synchronize"> 同步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table ref="registerTable" v-loading="tableLoading" :data="tableData" style="width: 100%" border :header-cell-style="headerCellStyle">
          <el-table-column prop="name" label="供应商名称" align="center" />
          <el-table-column prop="createTime" label="同步时间" align="center" />
          <el-table-column prop="status" label="是否完善" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.status == 0 ? '未完善' : '已完善' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="complete(scope.row)">完善</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" :current-page.sync="searchForm.page" :page-size="searchForm.rows" />
      </div>
    </div>
    <complete ref="completeRef" @completeSuccess="searchBtn" />
  </div>
</template>

<script>
  import { supplierInfoTransition, getSupplierMasterDate } from '@/service/basicfile';
  import Complete from '@/views/basicfile/carriers/components/complete.vue';

  export default {
    name: 'supplierManagement',
    components: { Complete },
    data() {
      return {
        pageLoading: false,
        searchForm: {
          name: '',
          status: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      /**
       * 同步
       */
      async synchronize() {
        this.$prompt('供应商名称', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
        }).then(async ({ value }) => {
          this.pageLoading = true;
          const { status, message } = await getSupplierMasterDate({ type: 2, nameChs: value });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.pageLoading = false;
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });  
        })
        // ---
        // this.pageLoading = true;
        // const { status, message } = await getSupplierMasterDate({ type: 2 });
        // this.pageLoading = false;
        // if (status !== 0) return this.$message.warning(message);
        // this.$message.success(message);
      },
      /**
       * 完善
       * @param data 行数据
       */
      async complete(data) {
        this.$refs.completeRef.dialogOpen(data);
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { data, status, message } = await supplierInfoTransition(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }

        .el-select__tags {
          max-width: 100% !important;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
